import connectAuth from './Auth/index.js';
import history from '../history';
import ccFetch from './ccFetch';


let appId = process.env.REACT_APP_AUTH_APPID
let { REACT_APP_PROTOCOL } = process.env
let auth = connectAuth({
  authDomain: `${REACT_APP_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}`,
  authLogonUri: `/${appId}/logon`,
  authLogoffUri: `/${appId}/logoff`,
  authRenewUri: `/${appId}/renew`,
  notAuthenticated: () => {
    history.push("/logon");
  }
})
const fetch = auth.ccAuthConnect(ccFetch)
const m_fetch = auth.MultipleFetch(ccFetch)
const logonFn =  auth.ccAuthLogon
const logoffFn = auth.logoff
const utils = auth.utils

export {
  fetch,
  m_fetch,
  logonFn,
  logoffFn,
  utils
}
